import { RuntimeRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";

class ZendeskPresenter extends Base2Presenter {
  initialState() {
    return {
      supportVisible: false,
      isOnSignUp: false,
      isLoggedOut: false,
      user: {}
    };
  }

  onStart() {
    this.onEnter();
    this.updateUser();
  }

  async updateUser() {
    const token = await this.mRuntime.get("token");
    const currentUser = await this.mRuntime.get("currentUser");

    const user = Object.assign({}, currentUser, { token })

    this.enqueue({ user })
  }

  onEnter() {
    this.router.transitionService.onEnter({}, transition => {
      const isOnSignUp = ["app.signup"].includes(transition.to().name);
      const isLoggedOut = ["app.login", "app.signup"].includes(
        transition.to().name
      );

      this.updateUser()
      this.enqueue({ isOnSignUp: isOnSignUp, isLoggedOut: isLoggedOut });
    });
  }

  onLoad() {
    const isLoggedOut = ["app.login", "app.signup"].includes(this.router.stateService.current.name)
    const isOnSignUp = this.router.stateService.current.name === "app.signup";

    this.enqueue({ isOnSignUp, isLoggedOut });
  }

  async hideWidget() {
    this.mRuntime.set(RuntimeRepository.props.supportVisible, false);
  }

  async showWidget() {
    this.mRuntime.set(RuntimeRepository.props.supportVisible, true);
  }
}

export default ZendeskPresenter;



// WEBPACK FOOTER //
// ./src/components/support/zendesk-widget/presenter.js